import planOptions from 'Data/plan_options.json';

const PLAN_BY_ID = {};

planOptions.forEach((plan) => {
  PLAN_BY_ID[plan.id] = plan;
});

export function getPlanIncludedUnits(planId) {
  return PLAN_BY_ID[planId].included_units;
}

export function getPlanType(planId) {
  return PLAN_BY_ID[planId].type;
}

export default {
  computed: {
    planOptions() {
      return planOptions.map(plan => ({
        value: plan.id,
        text: this.getPlanAdminLabel(plan.id),
      }));
    },
  },
  methods: {
    getPlanAdminLabel(planId) {
      return PLAN_BY_ID[planId].admin_label_ja;
    },
  },
};
